import { compose } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import withAuth from '../../common/WithAuth';
import ProductRegister from '../../pages/ProductRegister/ProductRegister';
import {
    getProductInfoRequested, getProductInfoClear, createProductRequested, createProductClear, updateProductRequested, updateProductClear,
} from '../../actions/ProductManagement';
import ProductManagementSelector from '../../selectors/ProductManagement';
import RegistrationOrganizerSelector from '../../selectors/RegistrationOrganizer';

const mapStateToProps = (state) => {
    const productData = ProductManagementSelector.createProductDataSelector()(state);
    const errorCreate = ProductManagementSelector.createProductDataCreateErrorSelector()(state);
    const isLoading = state.productManagement.getProduct.isFetching
    || state.productManagement.create.isFetching
    || state.productManagement.update.isFetching;

    return {
        locale: state.locale.lang.current,
        companyID: state.auth.credential.data.company_id && state.auth.credential.data.company_id.toString(),
        eventInfo: state.registration.registrationViewer.data,
        productData,
        errorCreate,
        successCreate: state.productManagement.create.success,
        loadingCreate: state.productManagement.create.isFetching,
        progessCreate: state.productManagement.create.percent,
        errorUpdate: state.productManagement.update.errors,
        successUpdate: state.productManagement.update.success,
        isLoading,
        token: state.auth.credential.data.token,
        settingsDisplayInfo: RegistrationOrganizerSelector.createSettingDisplayInfoProductSelector()(state),
        userInfo: state.companyManagementOrganizer.detailCompanyOrganizer.data.user,
    };
};

const mapDispatchToProps = (dispatch) => ({
    getProduct: (companyID, productID) => dispatch(getProductInfoRequested({ companyID, productID })),
    getProductClear: () => dispatch(getProductInfoClear()),
    createProduct: (companyID, params) => {
        dispatch(createProductRequested({ companyID, params }));
    },
    createProductClear: () => dispatch(createProductClear()),
    updateProduct: (companyID, productID, params) => {
        dispatch(updateProductRequested({ companyID, productID, params }));
    },
    updateProductClear: () => dispatch(updateProductClear()),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ProductRegister);
